// extracted by mini-css-extract-plugin
module.exports = {"bar":"BottomBar_style_bar__obRQ5","btns":"BottomBar_style_btns__24VYL","btn":"BottomBar_style_btn__2J8pg","appoint":"BottomBar_style_appoint__34DcI"};